import React from 'react';
import { PrimaryLoadingButton, PrimaryTooltip } from 'components';
import {
  IconButton,
  Typography,
} from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useSelector, useDispatch } from 'react-redux';
import { selectEnterprise } from 'base/core/selectors';
import { selectActionLoader, selectStripeAccountCompleted } from 'base/auth/selectors';
import { authSliceActions } from 'base/auth/slice';
import { openInNewTab } from 'utils/common-utils';
import { useFormContext } from 'react-hook-form';
import { Info } from '@mui/icons-material';
import { IUpdateProfileForm } from '../../interface';

const BankAccountDetailsForm = () => {
  const dispatch = useDispatch();
  const stripeAccountCompleted = useSelector(selectStripeAccountCompleted);
  const actionLoader = useSelector(selectActionLoader);
  const enterprise = useSelector(selectEnterprise);

  const {
    control,
    formState: { errors },
  } = useFormContext<IUpdateProfileForm>();

  const handleUpdateBankDetails = async () => {
    try {
      await new Promise((resolve, reject) => {
        dispatch(authSliceActions.generateConnectUrl({
          resolve,
          reject,
        }));
      });
      dispatch(authSliceActions.openStripeAccountLink());
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('-- generate stripe connect error --', error);
    }
  };

  const handleOpenDashboard = async () => {
    try {
      const url = await new Promise((resolve, reject) => {
        dispatch(authSliceActions.generateDashboardUrl({
          resolve,
          reject,
        }));
      });
      openInNewTab(url as string);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('-- generate stripe dashboard url error --', error);
    }
  };

  return (
    <>
      <div className="form-item">
        <div className="d-flex align-items-center mt-2 mb-1">
          <Typography variant="h5">Stripe account</Typography>
          <PrimaryTooltip title="All earnings transferred to your Stripe connected bank account will have Stripe Fees automatically deducted.">
            <IconButton><Info color="primary" /></IconButton>
          </PrimaryTooltip>
        </div>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
          {
            `Slocoach, our service provider for ${enterprise.name}, uses Stripe to get you paid quickly and keep your personal and payment information secure. Thousands of companies around the world trust Stripe to  process payments for their users. Set up a Stripe account to get paid with ${enterprise.name}.`
          }
        </Typography>
      </div>
      <div className="row">
        <div className="col-md-12 d-flex gap-2">
          <PrimaryLoadingButton
            startIcon={<AccountBalanceIcon sx={{ color: '#fff' }} />}
            onClick={handleUpdateBankDetails}
            loading={actionLoader}
          >
            {`${stripeAccountCompleted ? 'Update' : 'Setup'} stripe account`}
          </PrimaryLoadingButton>
          {stripeAccountCompleted && (
            <PrimaryLoadingButton
              startIcon={<OpenInNewIcon sx={{ color: '#fff' }} />}
              onClick={handleOpenDashboard}
              loading={actionLoader}
            >
              Stripe dashboard
            </PrimaryLoadingButton>
          )}
        </div>
      </div>
    </>
  );
};

export default BankAccountDetailsForm;
